import React from "react";

export type RowContextProps<T extends {}> = {
  rowId: string | number;
  rowData: T;
};

export const RowContext = React.createContext<RowContextProps<any>>({
  rowId: 0,
  rowData: {}
});
